export const environment = {
  name: 'staging',
  production: false,
  serverUrl: 'https://staging.api.caplock.app',
  lastCompilationTime: '2026-04-16T05:36:31.570Z',
  webUrl: 'https://staging.backoffice.caplock.app',
  awsRegion: 'eu-west-3',
  awsPictureBucket: 'staging-caplock-picture',
  awsPublicBucket: 'staging-caplock-public',
  userPoolId: 'eu-west-3_R2aDqQ4hi',
  userPoolWebClientId: 'phq4f0m87gihusmmn02v1enmc',
  databaseCoherencyUrl:'',
  missingPictureUrl: '',
};
